// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Play: React.FC<{ width?: number; height?: number }> = ({ width = 90, height = 90 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13 14">
            <path
                fill="currentColor"
                d="M1.84375,0.160257803 C1.46875,-0.0583640937 1,-0.0583640937 0.625,0.191489503 C0.21875,0.410111399 0,0.816123493 0,1.25336729 L0,12.7466327 C0,13.1838765 0.25,13.5898886 0.625,13.8085105 C1,14.0583641 1.46875,14.0583641 1.84375,13.8397422 L12.34375,8.09310948 C12.75,7.87448759 13,7.46847549 13,7 C13,6.53152451 12.75,6.12551241 12.34375,5.90689052 L1.84375,0.160257803 Z"
            />
        </svg>
    );
};

export default React.memo(Play);
